import {
  RugbyUnionEventDetailId,
  RugbyUnionEventStatusId,
} from '@collector/sportsapi-client-legacy'

import {
  createRugbyEventClockConfig,
  rugbyClockFixed,
  rugbyClockRunning,
  rugbyClockTiming,
  type RugbyStatusClockRule,
} from '../../configuration'

const t = rugbyClockTiming

const statusClock: Partial<
  Record<RugbyUnionEventStatusId, RugbyStatusClockRule>
> = {
  [RugbyUnionEventStatusId.NotStarted]: rugbyClockFixed(t.fromMatchStart),
  [RugbyUnionEventStatusId.FirstHalf]: rugbyClockRunning(
    t.fromMatchStart,
    t.periodLength,
  ),
  [RugbyUnionEventStatusId.Halftime]: rugbyClockFixed(t.periodLength),
  [RugbyUnionEventStatusId.SecondHalf]: rugbyClockRunning(
    t.periodLength,
    t.afterSecondHalf,
  ),
  [RugbyUnionEventStatusId.FinishedRegularTime]: rugbyClockFixed(
    t.afterSecondHalf,
  ),
  [RugbyUnionEventStatusId.WaitingForExtratime]: rugbyClockFixed(
    t.afterSecondHalf,
  ),
  [RugbyUnionEventStatusId.ExtratimeFirstHalf]: rugbyClockRunning(
    t.afterSecondHalf,
    (timing) => timing.periodLength * 2 + timing.extraPeriodLength,
  ),
  [RugbyUnionEventStatusId.ExtratimeHalftime]: rugbyClockFixed(
    t.afterExtraFirstHalf,
  ),
  [RugbyUnionEventStatusId.ExtratimeSecondHalf]: rugbyClockRunning(
    t.afterExtraFirstHalf,
    (timing) => timing.periodLength * 2 + timing.extraPeriodLength,
  ),
  [RugbyUnionEventStatusId.FinishedAfterExtratime]: rugbyClockFixed(
    t.afterExtraTime,
  ),
  [RugbyUnionEventStatusId.WaitingForPenalty]: rugbyClockFixed(
    t.afterPenalties,
  ),
  [RugbyUnionEventStatusId.Penalties]: rugbyClockFixed(t.afterPenalties),
  [RugbyUnionEventStatusId.FinishedAfterPenalties]: rugbyClockFixed(
    t.afterPenalties,
  ),
}

export const {
  getEventStatusPeriodLengthMinutes,
  getEventPeriodStartOffsetMinutes,
  getEventClockSeconds,
  isValidEventClockTime,
  getEventClockTime,
} = createRugbyEventClockConfig(statusClock)

export const extraTimeDetailId = RugbyUnionEventDetailId.FirstExtraHalfStartDate
